<template>
    <div>
      <el-card>
        <h2>用户充值申请</h2>
        <el-form :inline="true">
          <el-form-item label="用户账号">
            <el-input v-model="searchQuery.account" placeholder="请输入用户账号" />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleSearch">搜索</el-button>
          </el-form-item>
        </el-form>
  
        <el-table :data="rechargeList" border >
          <el-table-column prop="id" label="ID" width="80" />
          <el-table-column label="用户信息">
            <template #default="{ row }">
              <div>账号：{{ row.user.account }}</div>
              <div>用户名：{{ row.user.username }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="amount" label="充值金额" />
          <el-table-column prop="type" label="充值类型" />
          <el-table-column prop="method" label="充值方式" />
          <el-table-column prop="status" label="状态">
            <template #default="{ row }">
              <el-tag :type="row.status === 1 ? 'success' : row.status === 2 ? 'danger' : 'warning'">
                {{ row.status === 1 ? '已通过' : row.status === 2 ? '已拒绝' : '待处理' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="created_at" label="申请时间" />
          <el-table-column label="操作" width="200">
            <template #default="{ row }">
              <el-button v-if="row.status === 0" type="success" size="small" @click="handleDeposit(row, 1)">通过</el-button>
              <el-button v-if="row.status === 0" type="danger" size="small" @click="handleDeposit(row, 2)">拒绝</el-button>
            </template>
          </el-table-column>
        </el-table>
  
        <el-pagination
          :current-page="pagination.page"
          :page-size="pagination.limit"
          :total="total"
          @current-change="handlePageChange"
        />
      </el-card>
    </div>
  </template>
  
  <script>
  import { getUserRecharge, getHandleDeposit } from '@/api/money';
  
  export default {
    data() {
      return {
        searchQuery: {
          account: ''
        },
        rechargeList: [],
        pagination: {
          page: 1,
          limit: 20
        },
        total: 0
      };
    },
    created() {
      this.fetchData();
    },
    methods: {
      async fetchData() {
        const params = {
          ...this.searchQuery,
          page: this.pagination.page,
          limit: this.pagination.limit
        };
        const { data } = await getUserRecharge(params);
        this.rechargeList = data.items.map(item => ({
          ...item,
          user: item.user || { account: '', username: '' }
        }));
        this.total = data.total;
      },
      handleSearch() {
        this.pagination.page = 1;
        this.fetchData();
      },
      handlePageChange(page) {
        this.pagination.page = page;
        this.fetchData();
      },
      async handleDeposit(row, status) {
        try {
          await getHandleDeposit(row.id, status);
          this.$message.success(status === 1 ? '已通过充值申请' : '已拒绝充值申请');
          row.status = status;
        } catch (error) {
          this.$message.error('处理失败');
        }
      }
    }
  };
  </script>
  
  <style scoped>
  .el-card {
    margin: 20px;
  }
  
  .el-form-item {
    margin-bottom: 0;
  }
  
  .el-pagination {
    margin-top: 20px;
    text-align: right;
  }
  </style>